import api from "../core/api";
import VwHbsRaportiptanimverigirisDTO from "src/models/PatolojiModul/VwHbsRaportiptanimverigirisDTO";
import VwHastarapordetayDTO from "src/models/PatolojiModul/VwHastarapordetayDTO";
import VwPatolojiLaboratuvarDTO from "src/models/PatolojiModul/VwPatolojiLaboratuvarDTO";
import PatolojiNumuneKabulAramaKriterleri from "src/store/Slices/PatolojiModul/PatolojiNumuneKabulAramaKriterleri";
import VwHastaraporsurecDTO from "src/models/PatolojiModul/VwHastaraporsurecDTO";
import VwHastaraporimzaDTO from "src/models/PatolojiModul/VwHastaraporimzaDTO";
import PatolojiLaboratuvarDurumDegistir from "src/store/Slices/PatolojiModul/PatolojiLaboratuvarDurumDegistir";
import VwPatolojiLaboratuvarekislemDTO from "src/models/PatolojiModul/VwPatolojiLaboratuvarekislemDTO";
import PatolojiLabEkIslemEkle from "src/models/PatolojiModul/PatolojiLabEkIslemEkle";
import PatolojiIptalRequest from "src/models/PatolojiModul/PatolojiIptalRequest";
import PatolojiLaboratuvarGuncelleRequests from "src/models/PatolojiModul/PatolojiLaboratuvarGuncelleRequests";
import PatolojiProtokolDegistirRequest from "src/models/PatolojiModul/PatolojiProtokolDegistirRequest";
import PatolojiHastaRaporOnaylaRequest from "src/models/PatolojiModul/PatolojiHastaRaporOnaylaRequest";
import PatolojiRevizeRaporResponse from "src/models/PatolojiModul/PatolojiRevizeRaporResponse";
import VwPatolojiLaboratuvardetayDTO from "src/models/PatolojiModul/VwPatolojiLaboratuvardetayDTO";
import PatolojiRevizeRaporRequest from "src/models/PatolojiModul/PatolojiRevizeRaporRequest";
import VwSiPatolojidetaylistDTO from "src/models/PatolojiModul/VwSiPatolojidetaylistDTO";
import VwPatEimzakayitsayacDTO from "src/models/PatolojiModul/VwPatEimzakayitsayacDTO";

const controllerName = "Patoloji";

const PatolojiLaboratuvarIslemleriApi = api.injectEndpoints({
    endpoints: (builder) => ({
        PatolojiLaburatuvarIslemleriListe: builder.query<Array<VwPatolojiLaboratuvarDTO>, PatolojiNumuneKabulAramaKriterleri>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLaburatuvarIslemleriListe",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            providesTags: ["PatolojiLaboratuvarListesi"]
        }),
        PatolojiLaboratuvarDetayListe: builder.query<Array<VwPatolojiLaboratuvardetayDTO>, { muracaatId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLaboratuvarDetayListe",
                    method: "GET",
                    params: request
                }
            },
            keepUnusedDataFor: 0
        }),
        PatolojiLaboratuvarDurumDegistir: builder.mutation<string, PatolojiLaboratuvarDurumDegistir>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLaboratuvarDurumDegistir",
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["PatolojiLaboratuvarListesi"]
        }),
        PatolojiLaboratuvarSablonIslemOneri: builder.query<boolean, { islemTanimId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLaboratuvarSablonIslemOneri",
                    method: "GET",
                    params: request
                }
            }
        }),
        PatolojiLabCalismaListesiRaporTipTanimVeriGirisListe: builder.query<Array<VwHbsRaportiptanimverigirisDTO>, { raporTipTanimId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLabCalismaListesiRaporTipTanimVeriGirisListe",
                    method: "GET",
                    params: request
                }
            },
        }),
        PatolojiLabCalismaListesiHastaRaporDetay: builder.query<Array<VwHastarapordetayDTO>, { raporId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLabCalismaListesiHastaRaporDetay",
                    method: "GET",
                    params: request
                }
            },
            providesTags: ["HastaRaporDetay"]
        }),
        PatolojiLabCalismaListesiHastaRaporDetayEkle: builder.mutation<VwHastarapordetayDTO, VwHastarapordetayDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLabCalismaListesiHastaRaporDetayEkle",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["HastaRaporDetay"]
        }),
        PatolojiLabCalismaListesiHastaRaporDetayGuncelle: builder.mutation<VwHastarapordetayDTO, VwHastarapordetayDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLabCalismaListesiHastaRaporDetayGuncelle",
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["HastaRaporDetay"]
        }),
        PatolojiLabCalismaListesiHastaRaporOnayla: builder.mutation<string, PatolojiHastaRaporOnaylaRequest>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLabCalismaListesiHastaRaporOnayla",
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["PatolojiLaboratuvarListesi", "HastaRaporDetay", "PatolojiLabSurecBilgileri", "PatolojiLabImzaBilgileri"]
        }),
        PatolojiLabCalismaListesiSurecBilgileriListe: builder.query<Array<VwHastaraporsurecDTO>, { hastaRaporId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLabCalismaListesiSurecBilgileriListe",
                    method: "GET",
                    params: request
                }
            },
            providesTags: ["PatolojiLabSurecBilgileri"]
        }),
        PatolojiLabCalismaListesiImzaBilgileri: builder.query<Array<VwHastaraporimzaDTO>, { hastaRaporId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLabCalismaListesiImzaBilgileri",
                    method: "GET",
                    params: request
                }
            },
            providesTags: ["PatolojiLabImzaBilgileri"]
        }),
        PatolojiLabEkIslemler: builder.query<Array<VwPatolojiLaboratuvarekislemDTO>, { muracaatId: number, hastaIslemId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLabEkIslemler",
                    method: "GET",
                    params: request
                }
            },
            providesTags: ["PatolojiLabEkIslemler"]
        }),
        PatolojiLabEkIslemEkle: builder.mutation<string, PatolojiLabEkIslemEkle>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLabEkIslemEkle",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["PatolojiLabEkIslemler", "PatolojiLaboratuvarListesi"]
        }),
        PatolojiLaboratuvarGuncelle: builder.mutation<string, PatolojiLaboratuvarGuncelleRequests>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLaboratuvarGuncelle",
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["HastaRaporDetay", "PatolojiLabSurecBilgileri", "PatolojiLabImzaBilgileri", "PatolojiLaboratuvarListesi"]
        }),
        PatolojiIptal: builder.mutation<string, PatolojiIptalRequest>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiIptal",
                    method: "DELETE",
                    body: JSON.stringify(request)
                }
            }
        }),
        PatolojiProtokolDegistir: builder.mutation<string, PatolojiProtokolDegistirRequest>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiProtokolDegistir",
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["PatolojiLaboratuvarListesi"]
        }),
        PatolojiRevizeRaporDuzenle: builder.mutation<PatolojiRevizeRaporResponse, PatolojiRevizeRaporRequest>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiRevizeRaporDuzenle",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["PatolojiLaboratuvarListesi"],
        }),
        PatolojiRevizeRaporKontrol: builder.mutation<string, { hastaRaporId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiRevizeRaporKontrol",
                    method: "GET",
                    params: request
                }
            },
        }),
        PatolojiLabCalismaListesiDetayBilgileriListe: builder.query<Array<VwSiPatolojidetaylistDTO>, { hastaRaporId: number, muracaatId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiLabCalismaListesiDetayBilgileriListe",
                    method: "GET",
                    params: request
                }
            },
        }),
        PatolojiEImzaliKayitBilgisi: builder.query<VwPatEimzakayitsayacDTO, void>({
            query: (request) => {
                return {
                    url: controllerName + "/PatolojiEImzaliKayitBilgisi",
                    method: "GET",
                }
            },
            keepUnusedDataFor: 0,
        }),
    }),
});

export const {
    usePatolojiLaburatuvarIslemleriListeQuery,
    usePatolojiLaboratuvarDetayListeQuery,
    usePatolojiLaboratuvarDurumDegistirMutation,
    useLazyPatolojiLaboratuvarSablonIslemOneriQuery,
    usePatolojiLabCalismaListesiRaporTipTanimVeriGirisListeQuery,
    usePatolojiLabCalismaListesiHastaRaporDetayQuery,

    usePatolojiLabCalismaListesiHastaRaporDetayEkleMutation,
    usePatolojiLabCalismaListesiHastaRaporDetayGuncelleMutation,

    usePatolojiLabCalismaListesiHastaRaporOnaylaMutation,
    usePatolojiLabCalismaListesiSurecBilgileriListeQuery,
    usePatolojiLabCalismaListesiImzaBilgileriQuery,

    usePatolojiLabEkIslemlerQuery,
    usePatolojiLabEkIslemEkleMutation,
    usePatolojiLaboratuvarGuncelleMutation,
    usePatolojiIptalMutation,
    usePatolojiProtokolDegistirMutation,
    usePatolojiRevizeRaporDuzenleMutation,
    usePatolojiRevizeRaporKontrolMutation,
    usePatolojiLabCalismaListesiDetayBilgileriListeQuery,
    usePatolojiEImzaliKayitBilgisiQuery,
} = PatolojiLaboratuvarIslemleriApi;